import { useResolver } from '@ps/web-shared-components';
import URL from 'url-parse';

const useBonusGameResolver = (gameURL: string, query: object) => {
  const resolvedURL = useResolver(gameURL, {
    query
  });
  return new URL(resolvedURL)
    .set('origin', '')
    .set('hostname', '')
    .set('port', '')
    .set('protocol', '')
    .set('slashes', '')
    .toString();
};

export default useBonusGameResolver;
